export const zeroPad = (digit: number, places = 2) => {
	const zerosCount = places - digit.toString().length + 1;
	const leadingZeros = new Array(+(zerosCount > 0 && zerosCount)).join('0');
	return `${leadingZeros}${digit}`;
};

export const getDecimalScale = (exponentialNumber: number) => {
	const numberToString = exponentialNumber.toString();
	if (numberToString.indexOf('e') !== -1) {
		const exponent = parseInt(numberToString.split('-')[1], 10);
		return exponentialNumber.toFixed(exponent).toString().split('.')[1]?.length || 0;
	}
	return exponentialNumber.toString().split('.')[1]?.length || 0;
};

export const isLiveEnvironment = () => {
	if (process.env.NODE_ENV === 'production') {
		const environments = ['test', 'dev', 'pp', 'local'];
		return !environments.some((value) => window.location.host.includes(value));
	}
	return false;
};
